import '@/main.css'
import './main.css'

import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { portalFormFields } from '@portal/features/formFields/registry'
import { QueryClientProvider } from '@tanstack/react-query'
import { FormFieldsProvider } from '@zealth/core/formFields/context'
import React from 'react'
import ReactDOM from 'react-dom/client'

import { initSentry } from '@/config/sentry'
import { initAnalytics, registerRouterPageviews } from '@/features/analytics'
import { initGtm } from '@/features/analytics/gtm'
import theme from '@/ui/theme'

import App from './App'
import { DevTools } from './DevTools'
import { queryClient } from './queryClient'
import { router } from './router'

initSentry('portal')
initAnalytics()
initGtm()
registerRouterPageviews(router)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <FormFieldsProvider components={portalFormFields}>
          <App />
        </FormFieldsProvider>
      </QueryClientProvider>
    </ThemeProvider>
    {import.meta.env.DEV && <DevTools />}
  </React.StrictMode>
)
